import { forEach, findIndex } from "lodash";
import { newConstraintCell } from "../newCell";
import { PLANNER_REQUESTED } from "../../../columnTypes";

const setGroupingWithActualConstraints = ({
  grouping,
  constraints,
  allocationProjectLookup,
  columns,
}) => {
  const constraintsGroupId = grouping.isVirtualDirectConstraintGrouping
    ? grouping.parent.groupId
    : grouping.groupId;
  const constraintsForGrouping = constraints[constraintsGroupId];

  forEach(constraintsForGrouping, (constraint) => {
    const allocationProject =
      allocationProjectLookup[constraint.allocationProjectId];

    // If the allocation project is not found for the constraint, skip it
    if (!allocationProject) {
      return;
    }

    const cell = newConstraintCell(grouping, constraint, allocationProject);
    // Planner has 3 columns sharing the same allocationProjectId.
    // Attach target constraints to the requested column explicitly.
    const plannerRequestedCellIndex = findIndex(columns, {
      allocationProjectId: cell.allocationProjectId,
      columnType: PLANNER_REQUESTED,
    });
    let cellIndex = plannerRequestedCellIndex;
    if (cellIndex === -1) {
      cellIndex = findIndex(columns, {
        allocationProjectId: cell.allocationProjectId,
      });
    }

    grouping.constraints[cellIndex] = cell;
  });
};

export default setGroupingWithActualConstraints;
